import React from 'react';
import CTABanner from '../components/landingPage/CTABanner';
import SocialMediaCTA from '../components/SocialMediaCTA';
import NewsSection from '../components/landingPage/NewsSection';

const BusinessActivityPage = () => {
  return (
    <div className="min-h-screen pt-20 bg-gray-100 font-poppins">
      {/* Hero Section */}
      <section className="relative h-64 sm:h-80 md:h-96 bg-cover bg-center" style={{ backgroundImage: "url('/hero_img/image-03.jpg')" }}>
        <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
          <h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-center drop-shadow-lg font-poppins mx-auto w-11/12 md:w-3/4 lg:w-2/3">
            Our Business Activities
          </h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="container mx-auto px-4 py-12 sm:py-16">
        <h2 className="text-3xl sm:text-4xl font-bold text-main-blue mb-6 sm:mb-8 text-center">
          Specialty in Steel-Fabricated Elements and Structures
        </h2>
        <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6">
          The specialty of MK Metal & Engineering Works Sdn. Bhd. is different kinds of steel-fabricated elements and structures. Among them are important ones: Structural Steel Fabrication such as Load Bearing Steel Column, Beam.
        </p>
        <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6">
          Also Security gates, awnings, grilles, fencing around the premises, guard rails, stair hand rails, canopies, Steel Link Bridge, Bondek, and metal roofing etc are significant.
        </p>
      </section>

      {/* CTABanner, SocialMediaCTA, NewsSection */}
      <CTABanner className="my-8 sm:my-12" />
      <SocialMediaCTA className="my-8 sm:my-12" />
      <NewsSection className="my-8 sm:my-12" />
    </div>
  );
};

export default BusinessActivityPage;
